import { ResolveProblemList } from '@components/buzzkuri/model/program/ResolveProblemList'
import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { ResolveProblem } from '@type/buzzkuri/programs-categor'

type Props = {
  resolveProblems: ResolveProblem[]
  iconPath: string
}

export const ProgramAim = ({
  resolveProblems,
  iconPath,
}: Props): JSX.Element => {
  return (
    <div className="w-[87.2vw] lg:w-[62.6vw]">
      <ProgramDescriptionAccordion title="この研修プログラムの狙い">
        <ResolveProblemList {...{ resolveProblems, iconPath }} />
      </ProgramDescriptionAccordion>
    </div>
  )
}
